import * as React from 'react';
import { Image, StyleSheet } from 'react-native';
import { BodyLargeRegular, H1Emphasized, View, YStack } from 'smoothie';

import iPhoneMock from '../../../../assets/images/banking/cash-card-merchandising/iPhone-Mock.png';
import { InterestCard } from './FloatingCard';

const styles = StyleSheet.create({
    phoneImage: {
        position: 'relative',
        bottom: 20,
        left: 0,
        width: 320,
        height: 640,
    },
    phoneImageMobile: {
        position: 'relative',
        bottom: 20,
        left: 0,
        width: 216,
        height: 432,
    },
    heroText: {
        position: 'absolute',
        right: 0,
        top: '30%',
        width: '45%',
        alignItems: 'flex-end',
    },
});

interface HeroSectionProps {
    formattedApy: string;
    useLargePhoneMock: boolean;
}

const HeroSection = ({ formattedApy, useLargePhoneMock }: HeroSectionProps) => (
    <View
        position="relative"
        minHeight={340}
        paddingBottom={8}
        marginTop={-32}
        $mobile_norm={{ marginTop: 0 }}
        $sm={{
            marginTop: 64,
            minHeight: 430,
            paddingBottom: 28,
        }}
    >
        <View
            position="absolute"
            left={-16}
            top={0}
            zIndex={1}
            $sm={{ scale: 1.2, top: '-28%' }}
        >
            <Image
                source={iPhoneMock}
                style={
                    useLargePhoneMock
                        ? styles.phoneImage
                        : styles.phoneImageMobile
                }
                resizeMode="contain"
            />
            <View
                position="absolute"
                top="25%"
                left="40%"
                transform={[{ rotate: '8deg' }]}
                scale={0.65}
                $mobile_mini={{
                    scale: 0.65,
                }}
            >
                <InterestCard />
            </View>
        </View>
        <YStack style={styles.heroText} gap={4} zIndex={2}>
            <H1Emphasized
                color="$wasabi1200"
                $sm={{ fontSize: 54, lineHeight: 56 }}
            >
                {formattedApy}
            </H1Emphasized>
            <BodyLargeRegular
                color="$wasabi1200"
                $sm={{ fontSize: 30, lineHeight: 40 }}
                textAlign="right"
            >
                Annual Percentage Yield¹ on all your cash, whether you spend or
                save
            </BodyLargeRegular>
        </YStack>
    </View>
);

export default HeroSection;
